module.exports = __webpack_public_path__ + "img/5.e0937f1a.png";